const KEY = 'impersonate';

export const getImpersonatedEmail = (): string | null => {
    try {
        return localStorage.getItem(KEY);
    } catch {
        return null;
    }
};

const clearSessionCaches = () => {
    try {
        localStorage.removeItem('userProfile');
        localStorage.removeItem('selectedOrganizerId');
        localStorage.removeItem('cart');
    } catch {
        // storage unavailable
    }
};

export const startImpersonating = (email: string) => {
    clearSessionCaches();
    localStorage.setItem(KEY, email);
};

export const stopImpersonating = () => {
    clearSessionCaches();
    localStorage.removeItem(KEY);
};
